import React from 'react';
import { IconCopy } from '@tabler/icons-react';
import { type CountDownProps } from '@planne-software/uni';
import { Tooltip } from '@planne-software/uni/mui/material';

import { useTranslate } from '@src/core/hooks';

import { CodeColumn, CodeGroup, CodeLayout, CopyButton, PixCodeText, PixTimer, QrCodeFrame } from './styles';
import { useCopyFeedback } from '../hooks/useCopyFeedback';

type PixCodeBlockProps = {
  code: string;
  qrCode: string;
  secondsRemaining: number;
  timerSize: CountDownProps['size'];
  onTimerRanOut: () => void;
};

export const PixCodeBlock = (props: PixCodeBlockProps) => {
  const { code, qrCode, secondsRemaining, timerSize, onTimerRanOut } = props;
  const { i18n } = useTranslate();

  const { copied, copy } = useCopyFeedback(code);

  return (
    <CodeLayout data-testid='pix-code-block'>
      <QrCodeFrame>
        <img alt={i18n('checkout_qrCodeWithPixCode')} src={qrCode} />
      </QrCodeFrame>

      <CodeColumn>
        <PixTimer
          label={i18n('checkout_payment_pix_time_remaining')}
          totalSeconds={secondsRemaining}
          onComplete={onTimerRanOut}
          size={timerSize}
          align='left'
        />

        <CodeGroup>
          <PixCodeText>{code}</PixCodeText>
          <Tooltip
            open={copied}
            describeChild
            title={i18n('checkout_payment_pix_copied_tooltip')}
            placement='top'
            arrow
          >
            <CopyButton variant='contained' onClick={copy} startSlot={<IconCopy size={20} aria-hidden />}>
              {i18n('checkout_payment_pix_copy_button')}
            </CopyButton>
          </Tooltip>
        </CodeGroup>
      </CodeColumn>
    </CodeLayout>
  );
};

export default PixCodeBlock;
